module.exports = __webpack_public_path__ + "static/media/olivia-wilde-icon.0ad0a793.jpg";